"use strict";
define(
'stores/announcements',[
    "jquery",
    "stores/store",
    "actions/announcements",
    "constants/actiontypes"
],
function ($, StoreBase, Action, Constants)
{
    Store.prototype = new StoreBase();
    Store.constructor = Store;

    function Store (params)
    {
        // Call parent constructor
        StoreBase.call(this, params);

        // Setup the instance
        this.announcements = {};

        this.registerDispatchListener(function (action) {
            switch(action.actionType) {
                case Constants.CREATE_ANNOUNCEMENT:
                    if (Array.isArray(action.data)) {
                        _.each(action.data, function (data, index, list) {
                            this.addAnnouncement(data);
                        }, this);
                    } else {
                        this.addAnnouncement(action.data);
                    }
                    this.event.emit("change");
                    break;
            }
        }.bind(this));

        this.action = new Action();
        // this.action.pull();
    }

    Store.prototype.addAnnouncement = function(data)
    {
        this.announcements[data.guid] = data;
    };

    Store.prototype.getAll = function() {
        return this.announcements;
    }

    Store.prototype.get = function(guid) {
        if(guid in this.announcements) {
            return this.announcements[guid];
        }
        return null;
    }

    return Store;
});

